import React from "react";
import {
  render,
  MARK_BOLD,
  MARK_LINK,
  NODE_QUOTE,
  NODE_UL,
  NODE_LI,
  NODE_OL,
  NODE_PARAGRAPH,
  NODE_HEADING,
} from "storyblok-rich-text-react-renderer";
import TBBLink from "utils/TBBLink";
import Heading from "utils/Heading";

const RichText = ({ children, link, paragraph_classes, bold_classes }) => {
  return render(children, {
    markResolvers: {
      [MARK_LINK]: (children, props) => {
        const { href, target, linktype } = props;
        return (
          <TBBLink
            className={`text-[#000] hover:text-[#091DF3] ${link} underline duration-300`}
            to={linktype === "email" ? `mailto:${href}` : href}
            target={target}
          >
            {children}
          </TBBLink>
        );
      }
    },
    nodeResolvers: {
      [NODE_QUOTE]: (children) => (
        <blockquote
          className={`my-16 border-l-4 border-[#091DF3] px-2 pl-4 text-2xl not-italic !leading-[0.85] tracking-normal text-black before:hidden after:hidden lg:text-3xl`}
        >
          {children}
        </blockquote>
      ),
      [NODE_UL]: (children) => (
        <ul className={`marker:text-primary my-3 list-disc pl-5`}>
          {children}
        </ul>
      ),
      [NODE_LI]: (children) => <li className="">{children}</li>,
      [NODE_OL]: (children) => (
        <ol
          className={`my-3 list-decimal pl-7 marker:text-lg md:marker:text-xl lg:marker:text-[23px]`}
        >
          {children}
        </ol>
      ),
      [NODE_PARAGRAPH]: (children) => (
        <p
          className={
            paragraph_classes
              ? paragraph_classes
              : "text-lg font-light !leading-snug md:text-xl lg:text-[21px]"
          }
        >
          {children}
        </p>
      ),
      [NODE_HEADING]: (children, { level }) => {
        const HeadingLevel = `h${level}`;
        return (
          <Heading
            size={HeadingLevel}
            className={`!m-0 pt-6 pb-[1.25rem] font-normal`}
          >
            {children}
          </Heading>
        );
      },
    },
    blokResolvers: {
      code: (props) => (
        <div
          className="code"
          dangerouslySetInnerHTML={{ __html: props.code }}
        ></div>
      ),
    },
  });
};

export default RichText;
